<template>
  <div name="hres89u-popup-approve" id="hres89u-popup-approve" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal" ref="popupApproveModalButton">&times;</button>
          <h4 class="modal-title">{{ labels['HRES89UC2']['0'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive"> 
          <div class="detail detail-responsive">
          	<div class="detail-block">
         
							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['10'] }}</div>
							  <div class="detail-right">
							      <div class="detail-text width-70" id="dtereq" name="dtereq">{{ approve.dtereq }}</div>
							  </div>
							</div>

							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['20'] }}</div>
							  <div class="detail-right">
							     <div class="detail-text width-70" id="coddesc_codempid" name="coddesc_codempid">{{ approve.codempid }} - {{ approve.desc_codempid }}</div>
							  </div>
							</div>

							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['30'] }}</div>
							  <div class="detail-right">
							     <div class="detail-text width-70" id="desc_codcomp" name="desc_codcomp">{{ approve.desc_codcomp }}</div>
							  </div>
							</div>

							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['40'] }}</div>
							  <div class="detail-right">
							      <div class="detail-text width-70" id="desc_codpos" name="desc_codpos">{{ approve.desc_codpos }}</div>
							  </div>
							</div>
						</div>

						<div class="detail-block">
							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['50'] }}</div>
							  <div class="detail-right">
							  	<div class="input-group width-70">
						        <hrms-lov v-model="approve.codemprc"
						                  lovType="codempid"
						                  :disabled="false"
						                  :nowLang="nowLang"
						                  name="codempid1"
						                  :descDisp="true" />
							  	</div>
							  </div>
							</div>

							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['60'] }}</div>
							  <div class="detail-right">
						      <div class="input-group width-70">
	                  <hrms-datepicker  v-model="approve.dtestr"
	                                    v-validate="rules.approveDtestr"
	                                    data-vv-value-path="inputDate"
	                                    name="dtestr"
	                                    :has-error="errors.has('dtestr')" />
	                  <div class="text-error" v-show="errors.has('dtestr')">{{errors.first('dtestr')}}</div>  
	                </div>
							  </div>
							</div>

							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['70'] }}</div>
							  <div class="detail-right">
						      <div class="input-group width-70">
						      	<hrms-datepicker  v-model="approve.dteend" />
	                </div>
							  </div>
							</div>
						</div>

						<div class="">					
							<div class="detail-header">{{ labels['HRES89UC2']['80'] }}
							</div>
					
							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['90'] }}</div>
							  <div class="detail-right">
							      <div class="detail-text width-70" id="approvno" name="approvno">{{ approve.approvno }}</div>
							  </div>
							</div>

							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['100'] }}</div>
							  <div class="detail-right">
							     <div class="detail-text width-70" id="coddesc_codappr" name="coddesc_codappr">{{ approve.codappr }} - {{ approve.desc_codappr }}</div>
							  </div>
							</div>
							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['110'] }}</div>
							  <div class="detail-right">
						      <div class="input-group width-70">
	                  <hrms-datepicker  v-model="currentDate"
	                  									v-show="false"
	                                    v-validate="'required|date_format:DD/MM/YYYY'"
	                                    data-vv-value-path="inputDate"
	                                    name="currentDate"
	                                    :has-error="errors.has('currentDate')" />
	                  <hrms-datepicker  v-model="approve.dteappr"
	                                    v-validate="'required|date_format:DD/MM/YYYY|after:currentDate'"
	                                    data-vv-value-path="inputDate"
	                                    name="dteappr"
	                                    :has-error="errors.has('dteappr')" />
	                  <div class="text-error" v-show="errors.has('dteappr')">{{errors.first('dteappr')}}</div>  
	                </div>
							  </div>
							</div>

							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['120'] }}</div>
							  <div class="detail-right">
							      <div class="detail-text width-70" id="status" name="status">{{ approve.status }}</div>
							  </div>
							</div>

							<div class="clearfix detail-row">
							  <div class="detail-left label-left">{{ labels['HRES89UC2']['160'] }}</div>
							  <div class="detail-right">
								    <textarea class="textarea-text width-70" maxlength="500" id="remark" name="remark" 
								    					v-model="approve.remark" >
								    </textarea>
            				<div class="remark-limit-character">{{ dispLimitLabel(500) }}</div> 
								</div>
							</div>
						</div>

          </div>

        </div>

        <div class="modal-footer align-center border-color-skin">
          <button type="button" class="btn bg-green" @click="validatePopupApprove()" ><i class="fa fa-check-circle"></i> {{ labelsButton['approve'] }}</button>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres89u-popup-approve',
  data () {
    return {
      approve: {
        approvno: 0,
        chk_appr: '',
        numseq: '',
        dtereq: '',
        codempid: '',
        desc_codempid: '',
        codcomp: '',
        desc_codcomp: '',
        codpos: '',
        desc_codpos: '',
        codemprc: '',
        desc_codemprc: '',
        dtestr: '',
        dteend: '',
        codappr: '',
        desc_codappr: '',
        dteappr: '',
        staappr: '',
        flgStaappr: '',
        status: '',
        remark: ''
      },
      currentDate: moment().format('DD/MM/YYYY'),
      rules: {
        approveDtestr: ''
      }
    }
  },
  created () {
    if (typeof this.arrCodemprc[this.nowLang][this.approve.codemprc] === 'undefined') {
      this.approve.codemprc = ''
    }
  },
  watch: {
    indexSelected () {
      this.approve = {
        approvno: this.indexSelected.approvno,
        chk_appr: this.indexSelected.chk_appr,
        numseq: this.indexSelected.numseq,
        dtereq: this.indexSelected.dtereq,
        codempid: this.indexSelected.codempid,
        desc_codempid: this.indexSelected.desc_codempid,
        codcomp: this.indexSelected.codcomp,
        desc_codcomp: this.indexSelected.desc_codcomp,
        codpos: this.indexSelected.codpos,
        desc_codpos: this.indexSelected.desc_codpos,
        codemprc: this.detailSubmit.codemprc,
        desc_codemprc: this.detailSubmit.desc_codemprc,
        dtestr: this.detailSubmit.dtestr,
        dteend: this.detailSubmit.dteend,
        codappr: this.codappr,
        desc_codappr: this.descCodappr,
        dteappr: moment().format('DD/MM/YYYY'),
        staappr: this.indexSelected.staappr,
        flgStaappr: this.indexSelected.flgStaappr,
        status: this.indexSelected.status,
        remark: ''
      }
      this.setRuleDate()
      this.$nextTick(function () {
        this.errors.clear()
      })
    },
    detailSubmit () {
      this.approve = {
        approvno: this.indexSelected.approvno,
        chk_appr: this.indexSelected.chk_appr,
        numseq: this.indexSelected.numseq,
        dtereq: this.indexSelected.dtereq,
        codempid: this.indexSelected.codempid,
        desc_codempid: this.indexSelected.desc_codempid,
        codcomp: this.indexSelected.codcomp,
        desc_codcomp: this.indexSelected.desc_codcomp,
        codpos: this.indexSelected.codpos,
        desc_codpos: this.indexSelected.desc_codpos,
        codemprc: this.detailSubmit.codemprc,
        desc_codemprc: this.detailSubmit.desc_codemprc,
        dtestr: this.detailSubmit.dtestr,
        dteend: this.detailSubmit.dteend,
        codappr: this.codappr,
        desc_codappr: this.descCodappr,
        dteappr: moment().format('DD/MM/YYYY'),
        staappr: this.indexSelected.staappr,
        flgStaappr: this.indexSelected.flgStaappr,
        status: this.indexSelected.status,
        remark: ''
      }
    }
  },
  props: [ 'labels', 'labelsButton', 'nowLang', 'postHres89uSendApprove', 'indexSelected', 'codappr', 'descCodappr', 'arrCodemprc', 'detailSubmit', 'receivedHres89uDetailSubmit' ],
  methods: {
    setRuleDate () {
      this.rules.approveDtestr = (this.indexSelected.chk_appr === 'E') ? 'required|date_format:DD/MM/YYYY|after:dteappr' : ''
    },
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    validatePopupApprove () {
      this.setRuleDate()
      this.$validator.validateAll().then(result => {
        if (result) {
          let _this = this
          swal({
            title: constLabels('confirmTitle'),
            text: constLabels('msgConfirmSave'),
            html: true,
            showCancelButton: true,
            closeOnConfirm: false,
            confirmButtonText: constLabels('ok'),
            cancelButtonText: constLabels('cancel')
          },
          function (isConfirm) {
            if (isConfirm) {
              _this.postHres89uSendApprove(_this.sendApprove())
            }
          })
        }
      })
    },
    sendApprove () {
      return {
        approveParams: this.approve,
        referenceButton: this.$refs.popupApproveModalButton
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// popupApprove.vue?fba293c8